import { useEffect } from 'react'
import { usePageViewEvent } from '@fs/zion-analytics'
import useNavigate from './useNavigate'

/**
 * Custom hook to send page view events to analytics
 * Automatically prevents sending events in demo mode
 *
 * @param {string} pageDetail - The page detail to send to analytics (e.g., 'Get Started Helper Step 1')
 *
 * @example
 * useSendPageView('Get Started Helper Step 1')
 */
export default function useSendPageView(pageDetail) {
  const sendPageView = usePageViewEvent()
  const { isTryDemo } = useNavigate()

  useEffect(() => {
    if (!isTryDemo) {
      sendPageView({ page_detail: pageDetail })
    }
  }, [isTryDemo, pageDetail, sendPageView])
}
